import { render, staticRenderFns } from "./colegios.vue?vue&type=template&id=6f8577cf"
import script from "./colegios.vue?vue&type=script&lang=js"
export * from "./colegios.vue?vue&type=script&lang=js"
import style0 from "./colegios.vue?vue&type=style&index=0&id=6f8577cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports